import { ToggleButtonChoice } from './ToggleButtonChoice';
import { ToggleButtonRoot } from './ToggleButtonRoot';

export const ToggleButton = {
  Root: ToggleButtonRoot,
  Choice: ToggleButtonChoice,
};
